import { useMemo } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useHasUnsavedChanges = () => {
  const { state } = useCampaignEditorContext();

  return useMemo(() => !!state.edit, [state.edit]);
};
